/**
 * MUI component overrides to match current design
 */

import { Components, Theme } from '@mui/material/styles';

export const components: Components<Theme> = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '14px',
        textTransform: 'none',
        fontWeight: 500,
        padding: '8px 16px',
      },
      contained: {
        boxShadow: '0 1px 4px rgba(2,6,23,0.06)',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(2,6,23,0.08)',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '18px',
        boxShadow: '0 1px 4px rgba(2,6,23,0.06)',
        border: '1px solid',
        borderColor: 'rgba(0, 0, 0, 0.06)',
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(2,6,23,0.08)',
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: '18px',
      },
      elevation1: {
        boxShadow: '0 1px 4px rgba(2,6,23,0.06)',
      },
      elevation2: {
        boxShadow: '0 4px 12px rgba(2,6,23,0.08)',
      },
      elevation3: {
        boxShadow: '0 8px 24px rgba(2,6,23,0.10)',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: '14px',
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: '999px',
        fontWeight: 500,
      },
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
        height: '6px',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '18px',
      },
    },
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: '12px',
        boxShadow: '0 8px 28px rgba(2,6,23,0.18), 0 4px 12px rgba(2,6,23,0.12)',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: '10px',
        marginBottom: '8px',
        transition: 'background 150ms ease, transform 150ms ease',
        '&:hover': {
          transform: 'translateY(-2px)',
        },
      },
    },
  },
};
